import PropTypes from 'prop-types';

export default PropTypes.shape({
  assignee: PropTypes.string.isRequired,
  assigneeId: PropTypes.number.isRequired,
  assigneeImageUrl: PropTypes.string,
  assigneeInitials: PropTypes.string,
  body: PropTypes.string,
  completedAt: PropTypes.string,
  dueDate: PropTypes.string,
  id: PropTypes.number.isRequired,
  logged: PropTypes.bool.isRequired,
  owner: PropTypes.string.isRequired,
  ownerImageUrl: PropTypes.string,
  ownerInitials: PropTypes.string,
  reminderTime: PropTypes.string,
  taskType: PropTypes.string.isRequired,
  title: PropTypes.string,
  associatedModels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    associatedModelId: PropTypes.number.isRequired,
    associatedModelType: PropTypes.string.isRequired,
    _destroy: PropTypes.bool
  })).isRequired
});
